module.exports = "<div id=\"{{id}}\" class=\"input-group date\">\n    <input type=\"text\" class=\"form-control\">\n    <span class=\"input-group-addon\">\n       <span class=\"glyphicon glyphicon-time\"></span>\n    </span>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/timepicker/timepicker.component.html
// module id = ./src/app/shared/components/timepicker/timepicker.component.html
// module chunks = main